export const annotationDashboardMessagesEn = {
  // Header section
  'annotationDashboard.header.title': 'Dashboard',
  'annotationDashboard.header.subtitle':
    'Administer projects, users, organizations, and condition areas.',

  // Annotation Cards section
  'annotationDashboard.mywork.cardsSection.title': 'My workspace',
  // Pending tasks card
  'annotationDashboard.annotation.currentAssignments.card.title': 'My assignments',
  // Batch review card
  'annotationDashboard.annotation.batchReview.card.title': 'Review conflicts',
  'annotationDashboard.annotation.batchReview.card.description': 'Active conflicts',
  // My project card
  'annotationDashboard.annotation.myProjects.card.title': 'My projects',
  'annotationDashboard.annotation.myProjects.card.description': 'Active projects',

  // Empty state message
  'annotationDashboard.annotation.noTaskAssigned': 'You have no task assigned!',

  // Current assignments card
  'annotationDashboard.annotation.currentAssignments.card.pending': 'pending',
  'annotationDashboard.annotation.currentAssignments.card.draft': 'draft',
  'annotationDashboard.annotation.currentAssignments.card.finalized': 'finalized',

  // Administration Cards section
  'annotationDashboard.administration.cardsSection.title': 'Administration',
  // Card - Manage projects
  'annotationDashboard.administration.manageProjects.card.title': 'Projects',
  'annotationDashboard.administration.manageProjects.card.description': 'All projects',
  // Card - Manage users
  'annotationDashboard.administration.manageUsers.card.title': 'Users',
  // Card - Manage administrations
  'annotationDashboard.administration.myOrganizations.card.title': 'Health systems',
  // Card - Manage conditions
  'annotationDashboard.administration.manageConditions.card.title': 'Condition areas',
};
